import { render, staticRenderFns } from "./riskManagement.vue?vue&type=template&id=75bd8b88"
import script from "./riskManagement.vue?vue&type=script&lang=js"
export * from "./riskManagement.vue?vue&type=script&lang=js"
import style0 from "./riskManagement.vue?vue&type=style&index=0&id=75bd8b88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports